import React from 'react';
import { ProductColorSelector } from '@ajat/design-system/Configurator';
import { ComponentPage, DemoCard, DemoRow, Demo } from '../../shared';

export const meta = {
  component: ProductColorSelector,
  title: 'Product Color Selector',
  group: 'Configurator',
  importPath: '@ajat/design-system/Configurator',
  figmaNode: '4277:23148',
  description:
    'Compact trigger for the product colour: 32px swatch, colour name and a chevron. It only opens the picker — wire `onClick` to whatever renders the ColorSelector list, and pass `aria-expanded` / `aria-haspopup` through. Hover is desktop-pointer only.',
  props: [
    ['color', 'string', "'var(--color-gray-0)'", 'Swatch colour — hex, rgb, or a token'],
    ['name', 'string', '—', 'Colour name (typo-h6, uppercase); the aria-label when compact'],
    ['compact', 'bool', 'false', 'Mobile trigger: 52×36 on gray-1, 28px swatch, chevron only'],
    ['ariaLabel', 'string', '—', 'Accessible name — say what the button does ("Change colour, selected: White"); compact falls back to the colour name'],
    ['onClick', 'func', '—', 'Opens the colour picker'],
    ['className', 'string', "''", 'Additional CSS class'],
  ],
  usage: [
    {
      title: 'Colour trigger',
      code: `import { ProductColorSelector } from '@ajat/design-system/Configurator';

<ProductColorSelector
  color={selectedColor.hex}
  name={selectedColor.name}
  aria-haspopup="listbox"
  aria-expanded={pickerOpen}
  onClick={() => setPickerOpen((open) => !open)}
/>`,
    },
  ],
};

export default function ProductColorSelectorPage() {
  return (
    <ComponentPage meta={meta}>
      <DemoCard title="States" hint="hover for the Hover state">
        <DemoRow align="center">
          <Demo caption="DEFAULT" center><ProductColorSelector color="var(--color-gray-0)" name="Vit" /></Demo>
          <Demo caption="COMPACT" center><ProductColorSelector compact color="var(--color-gray-0)" name="Vit" /></Demo>
        </DemoRow>
      </DemoCard>

      <DemoCard title="Colours">
        <div className="flex flex-wrap items-center gap-medium-s">
          <ProductColorSelector color="var(--color-gray-0)" name="Vit" />
          <ProductColorSelector color="#080c0a" name="Svart" />
          <ProductColorSelector color="#1B365D" name="Marin" />
          <ProductColorSelector color="#8B1A1A" name="Vinröd" />
        </div>
      </DemoCard>
    </ComponentPage>
  );
}
